import React from 'react';
import { useEffect, useState, Fragment } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Button, Box, Select, MenuItem } from '@mui/material';
import { supabase } from '../../../api';
import { PROFILE_TABLE } from '../../../constants/supabase_constants';

const revenueList = [
  'Private',
  '< $100 ARR',
  '< $1,000 ARR',
  '< $5,000 ARR',
  '< $10,000 ARR',
  '< $25,000 ARR',
  '< $50,000 ARR',
  '< $100,000 ARR',
  '< $1,000,000 ARR',
  '> $1,000,000 ARR',
];

const StepSevenCompanySize = (props) => {
  const [loading, setLoading] = useState(true);
  const [revenue, setRevenue] = useState(null);

  let { id } = useParams();

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(`firstName, revenue`)
        .eq('id', id)
        .single();

      if (data) {
        // setFirstName(data.firstName);
        setRevenue(data.revenue);
      }

      if (error && status !== 406) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async () => {
    try {
      setLoading(true);

      const updates = {
        id: id,
        revenue: revenue,
        updated_at: new Date(),
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal', // Don't return the value after inserting
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
      props.handleNext();
    }
  };

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Fragment>
          <Typography variant='h4' sx={{ mt: '3rem', mb: '1rem', fontWeight: 'bold' }}>
            What is your company's ANNUAL revenue (USD)?
          </Typography>
          <Typography variant='body1' sx={{ mb: '3rem' }}>
            We need this to match you into an appropriate mastermind group, if you are part of The Mastermind
            Membership.
          </Typography>

          <form onSubmit={updateProfile}>
            <Select
              fullWidth
              size='small'
              value={revenue || ''}
              onChange={(e) => setRevenue(e.target.value)}
              sx={{ mb: '1.5rem' }}>
              {revenueList.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>

            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button color='inherit' disabled={props.activeStep === 0} onClick={props.handleBack} sx={{ mr: 1 }}>
                Back
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button type='submit'>Next</Button>
            </Box>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
};

export default StepSevenCompanySize;
